import { render, staticRenderFns } from "./PerPage.vue?vue&type=template&id=64295d55&scoped=true&"
import script from "./PerPage.vue?vue&type=script&lang=ts&"
export * from "./PerPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64295d55",
  null
  
)

export default component.exports